import Component from './Profile'

export default Component
